var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoUntitled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 85,
    viewBox: "0 0 126 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 85H113.441L80.0935 11.5628L79.9932 11.3418L79.9055 11.5628L66.7697 47.1542L57.0619 73.4309L56.1407 75.9316C54.1289 81.3815 48.9648 85 43.1928 85H0V0H38.9437C46.5708 0 52.7564 6.23291 52.7564 13.9183V47.1542H41.2814V25.4874C41.2814 17.802 35.0957 11.5691 27.4687 11.5691H11.4688V73.4435H35.2148C40.9868 73.4435 46.1509 69.8313 48.1626 64.3815L52.7564 51.9473L54.5238 47.1668L67.6658 11.5754L71.9337 0H87.4511L126 85Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUntitled);
export default __webpack_public_path__ + "static/media/logo-untitled.83281e608702380c7c80e41728b0ac1c.svg";
export { ForwardRef as ReactComponent };